// src/pages/conversaciones/components/ChatSidebar.tsx
import { Card, Avatar, Button } from '@/components/ui';
import { Building, User, UserPlus } from 'lucide-react';
import { formatDateTime } from '@/lib/utils';
import type { Conversacion } from '@/types';

interface Props {
  conversacion: Conversacion;
}

export function ChatSidebar({ conversacion }: Props) {
  return (
    <div className="w-80 space-y-4">
      {/* Info del Cliente */}
      <Card className="p-4">
        <h3 className="font-semibold mb-3">Informacion del Cliente</h3>
        <div className="space-y-3">
          <div className="flex items-center gap-3">
            <Avatar fallback={conversacion.cliente?.nombre} size="lg" />
            <div>
              <p className="font-medium">{conversacion.cliente?.nombre}</p>
              {conversacion.empresa && (
                <p className="text-sm text-gray-500 flex items-center gap-1">
                  <Building className="h-3 w-3" />
                  {conversacion.empresa.nombre}
                </p>
              )}
            </div>
          </div>

          {conversacion.contacto && (
            <div className="flex items-center gap-2 text-sm text-gray-600">
              <User className="h-4 w-4" />
              Contacto: {conversacion.contacto.nombre}
            </div>
          )}
        </div>
      </Card>

      {/* Asignacion */}
      <Card className="p-4">
        <h3 className="font-semibold mb-3">Asignacion</h3>
        {conversacion.asignado_a ? (
          <div className="flex items-center gap-3">
            <Avatar fallback={conversacion.asignado_a.nombre} size="sm" />
            <span>{conversacion.asignado_a.nombre}</span>
          </div>
        ) : (
          <div className="text-gray-500 text-sm">Sin asignar</div>
        )}
        <Button variant="outline" size="sm" className="w-full mt-3" disabled>
          <UserPlus className="h-4 w-4 mr-2" />
          {conversacion.asignado_a ? 'Reasignar' : 'Asignar'}
        </Button>
      </Card>

      {/* Detalles */}
      <Card className="p-4">
        <h3 className="font-semibold mb-3">Detalles</h3>
        <div className="space-y-2 text-sm">
          <div className="flex justify-between">
            <span className="text-gray-500">Mensajes</span>
            <span>{conversacion.mensajes_count ?? 0}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-500">Creada</span>
            <span>{formatDateTime(conversacion.created_at)}</span>
          </div>
          {conversacion.pausado_hasta && (
            <div className="flex justify-between">
              <span className="text-gray-500">Pausada hasta</span>
              <span>{formatDateTime(conversacion.pausado_hasta)}</span>
            </div>
          )}
        </div>
      </Card>
    </div>
  );
}
